import { eksmoBP } from 'Lib/bp/bp';
import { speed } from 'Lib/speed/speed';
import { getW } from 'Lib/w/w';
import 'Vendor/owlcarousel/owl.carousel.min';

const $metronom = $('.metronom');
const sFirstPopup = '.metronom__first-popup';
const cFirstPopupActive = 'metronom__first-popup_active';
const $firstPopupClose = $('.metronom__first-popup-close, .metronom__first-popup-btn');
const $baloon = $('.metronom__baloon');
const $popup = $('.metronom__popup');
const cPopupActive = 'metronom__popup_active';
const $popupClose = $('.metronom__popup-close');
const $slider = $('.metronom__slider');
const cSliderOn = 'owl-carousel';
const $body = $('body');
const cBodyPopup = 'js-metronom-popup';
const $map = $('.metronom__map').first();
const cMapActive = 'metronom__map_active';

function setOwlStageHeight(e) {
    let maxHeight = 0;

    $(e.target).find('.owl-item.active').each(function () {
        const thisHeight = parseInt($(this).height());

        maxHeight = (maxHeight >= thisHeight ? maxHeight : thisHeight);
    });

    $(e.target).find('.owl-carousel').css('height', maxHeight);
    $(e.target).find('.owl-stage-outer').css('height', maxHeight);
}

$slider.trigger('destroy.owl.carousel')
    .removeClass(cSliderOn)
    .addClass(cSliderOn)
    .owlCarousel({
        autoWidth: false,
        smartSpeed: speed * 2,
        dots: false,
        nav: true,
        items: 1,
        slideBy: 1,
        margin: 0,
        navClass: ['metronom__prev arrow arrow_prev arrow_shadow arrow_border', 'metronom__next arrow arrow_next arrow_shadow arrow_border'],
        navText: ['', ''],
        onInitialized: setOwlStageHeight,
        touchDrag: false,
        mouseDrag: false,
        autoHeight: true,
        onResized: setOwlStageHeight,
        onTranslated: setOwlStageHeight,
    });

$firstPopupClose.on('click', function () {
    $(this).closest(sFirstPopup).removeClass(cFirstPopupActive);

    if ($map) {
        $map.addClass(cMapActive);
    }
});

$popupClose.on('click', function () {
    const scrollTop = $metronom.offset().top;

    $('html, body').scrollTop(scrollTop - 150);
    $body.removeClass(cBodyPopup);
    $(this).closest($popup).removeClass(cPopupActive);
});

$baloon.on('click', function () {
    const id = parseInt($(this).attr('data-val'));
    const scrollTop = $metronom.offset().top;

    if (id && $popup.length) {
        if (getW() <= eksmoBP.xsMax) {
            $body.addClass(cBodyPopup);
        }

        $('html, body').scrollTop(scrollTop - 150);
        $slider.trigger('to.owl.carousel', [id - 1, 0]);
        $popup.addClass(cPopupActive);
    }
});